import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { BaseFormComponent } from 'src/app/shared/crud/base-form.component';

import { LayoutUtilsService } from './../../core/_base/crud/utils/layout-utils.service';
import { AuthAdminService } from 'src/app/core/auth/service/auth-admin.service';
import { ActivatedRoute } from '@angular/router';

@Directive()
export abstract class BaseForgotPasswordComponent
  extends BaseFormComponent
  implements OnInit, OnDestroy
{
  requestSuccess = false;

  constructor(
    protected authService: AuthAdminService | null = null,
    protected fb: FormBuilder | null = null,
    protected cdr: ChangeDetectorRef | null = null,
    protected layoutUtilsService: LayoutUtilsService | null = null,
    protected route: ActivatedRoute | null = null,
  ) {
    super();
  }

  ngOnInit(): void {
    this.handleCompanyKey();
    super.initForm();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  createForm() {
    this.form = this.fb?.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit() {
    if (!this.validateForm()) {
      this.cdr?.detectChanges();
      return;
    }

    this.loadingSubject.next(true);
    const reset = this.form.getRawValue();

    this.authService
      ?.forgotPassword(reset)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
          this.cdr?.detectChanges();
        })
      )
      .subscribe(
        () => {
          this.layoutUtilsService?.showActionNotification({
            title: 'Solicitação Enviada!',
            html: `Te enviamos um email de confirmação para gerar sua nova senha
            <br><br>
            <small class="fs-8">* Lembre-se de verificar a caixa de spam caso não encontre o email na caixa de entrada.</small>`,
            icon: 'success',
            heightAuto: false
          });

          this.router?.navigate([
            '/' +
              this.route?.parent?.snapshot.params.companyToken +
              '/auth/login',
          ]);
        },
        (err) => {
          this.form.reset();
          this.layoutUtilsService?.showToastNotification({
            title: err.error['hydra:description'],
            icon: 'error',
          });
        }
      );
  }
}
